import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	inputVariableChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600]),
		borderRadius: theme.spacing(1),
		color: colors.gray[0],
		fontWeight: "bold"
	}
}))

export default useStyles
